import { createSlice } from "@reduxjs/toolkit";
// Note: We remove toast from here. Reducers must be pure.
// Any error toasts should be triggered in the component or the async thunk where the error actually happens.

const initialState = {
  loading: false, // Changed from true to false, as it shouldn't be loading until instructed
  user: {},
  error: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // 1. Replaces SET_USER
    setUser: (state, action) => {
      // RTK uses Immer, so we can directly assign the payload
      state.user = action.payload;
      state.loading = false;
      state.error = "";
    },

    // 2. Replaces USER_REQUEST (If you still need to trigger a loading state manually)
    userRequest: (state) => {
      state.loading = true;
      state.error = "";
    },

    // 3. Replaces USER_ERROR
    userError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export the action creators for your components to use
export const { setUser, userRequest, userError } = userSlice.actions;

// Export the reducer to be included in rootReducer.js
export const UserReducer = userSlice.reducer;
